import { useEffect } from 'react';
import usePrevious from './usePrevious';

export const useThrowIfPropHasChanged = (name: string, prop: any) => {
  const prevProp = usePrevious(prop);
  useEffect(() => {
    if (prevProp != null && prevProp !== prop) {
      throw new Error(`${name} has Changed`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prop]);
};
